// SPDX-FileCopyrightText: 2026 Mads Ringblom
//
// SPDX-License-Identifier: GPL-3.0-or-later

import type { TableView } from '../../bygning/selection';
import { SegmentedControl } from '../SegmentedControl';

const VIEWS: readonly { value: TableView; label: string }[] = [
  { value: 'typer', label: 'Typer' },
  { value: 'dele', label: 'Dele' },
];

export interface TableViewSwitchProps {
  /** `?tview=`, shared by the Model's strip, Tabel and Galleri. */
  value: TableView;
  onChange: (view: TableView) => void;
  /** The group's accessible name: the view it switches ("Model", "Tabel", "Galleri"). */
  label: string;
  className?: string;
}

/** Typer | Dele, first in Tabel's and Galleri's toolbars and atop the Model's filters: a bar-size toggle group. */
export function TableViewSwitch({ value, onChange, label, className }: TableViewSwitchProps) {
  return (
    <SegmentedControl role="group" aria-label={label} size="md" items={VIEWS} value={value} onChange={onChange} className={className} />
  );
}
